module.exports = __webpack_public_path__ + "static/img/f4.2889352.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/custom/f4.png
// module id = XQUZ
// module chunks = 0